// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2_qf9","clinicsSelect":"TableHeading_clinicsSelect__1XUNg"};